import { render } from "./Captain.vue?vue&type=template&id=03ce7c4e"
import script from "./Captain.vue?vue&type=script&lang=js"
export * from "./Captain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__